import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import { AppDispatch } from "../../store/configureStore";
import { logoutRequested } from "../../store/users/auth";

import "./LoginPage.css";

const ADLogoutPage = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch({ type: logoutRequested.type });
  }, [dispatch]);

  return <Navigate replace to="/" />;
};

export default ADLogoutPage;
